// extracted by mini-css-extract-plugin
export default {"headingThreeText":"HeadingThree_headingThreeText__j-WhV"};